import View from '@play-co/timestep-core/lib/ui/View';
import PopupBasic from 'src/game/components/popups/PopupBasic';
import { Feature } from 'src/replicant/analytics';
import sounds from 'src/lib/sounds';
import {
  CardCollectionsHeader,
  CollectionsHeaderState,
} from '../components/CardCollectionsHeader';
import {
  CardCollectionsList,
  CollectionListState,
} from '../components/CardCollectionsList';
import ButtonScaleView from 'src/lib/ui/components/ButtonScaleView';
import { openPopupPromise } from 'src/lib/popups/popupOpenClose';
import { getScreenDimensions } from 'src/lib/utils';
import { AssetGroup } from '@play-co/timestep-core';
import uiConfig from 'src/lib/ui/config';
import TilingBackground from 'src/game/minigame/match2-timestep/team/components/TilingBackground';
import { cardsGetCollectionsPopupState } from '../cards.sequence';

export default class PopupCardCollections extends PopupBasic {
  private header: CardCollectionsHeader;
  private content: CardCollectionsList;

  constructor(opts: { superview: View; close: VoidFunction }) {
    const width = opts.superview.style.width;
    const height = getScreenDimensions().height;

    super({
      superview: opts.superview,
      skipBackground: true,
      skipTitle: true,
      width,
      height,
      close: () => {
        opts.close();
      },
      tracking: {
        feature: Feature.CARDS._,
        $subFeature: Feature.CARDS.COLLECTION,
      },
      zIndex: 10000,
    });

    this.box.updateOpts({
      backgroundColor: '#643DAC',
    });

    new TilingBackground({
      tileOpts: {
        image: 'assets/ui/cards/popupCardCollections/pattern.png',
        columns: 4,
      },
      maskOpts: {
        superview: this.box,
        width: this.box.style.width,
        height: this.box.style.height,
      },
      movementOpts: {
        speed: -2,
        direction: 'diagonal',
      },
    });

    this.header = new CardCollectionsHeader({
      superview: this.box,
      zIndex: 1,
      onInboxClose: () => this.refreshState(),
    });

    const headerVisibleHeight = this.header.style.height - 13;

    this.content = new CardCollectionsList({
      superview: this.box,
      y: headerVisibleHeight,
      width: this.box.style.width,
      height: this.box.style.height - headerVisibleHeight,
      onCollectionPopupClose: () => this.refreshState(),
    });

    // Info button
    new ButtonScaleView({
      superview: this.box,
      ...uiConfig.buttons.info,
      centerOnOrigin: true,
      x: 50,
      y: 50,
      tracking: {
        feature: Feature.CARDS._,
        $subFeature: Feature.CARDS.BUTTON_INFO,
      },
      onClick: async () => {
        sounds.sfx.play('ok');
        openPopupPromise('popupCardsInfo', {});
      },
    });

    this.buttonClose.updateOpts({
      x: this.box.style.width - 50,
      y: 50,
    });
  }

  protected getAssetsGroup() {
    return new AssetGroup([
      ...AssetGroup.constructURLs([
        'assets/ui/cards/common',
        'assets/ui/cards/popupCardCollections',
        'assets/ui/shared/icons/notification_badge.png',
      ]),
      uiConfig.buttons.info.image,
      uiConfig.buttons.info.imagePressed,
      uiConfig.buttons.info.imageDisabled,
      'assets/sounds/music/Match3_BGM.mp3',
    ]);
  }

  public async init(state: CollectionsHeaderState & CollectionListState) {
    super.init({});
    this.setState(state);
  }

  public async fadeIn() {
    await super.fadeIn();
    sounds.music.play('cards');
  }

  public fadeOut() {
    sounds.music.play('bgm');
    super.fadeOut();
  }

  private refreshState() {
    this.setState(cardsGetCollectionsPopupState());
  }

  private setState(state: CollectionsHeaderState & CollectionListState) {
    this.header.setState(state);
    this.content.setState(state);
  }
}
